import { Navigate } from 'react-router-dom';

type PrivateRouteProps = {
  component: any,
  authenticated: boolean,
  [x: string]: any
}
const PrivateRoute = ({
  component: Component,
  authenticated,
  ...restProps
}: PrivateRouteProps) => authenticated ? <Component {...restProps} /> : <Navigate to="/" />;

export default PrivateRoute;
